import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import SignalWifiOffIcon from '@mui/icons-material/SignalWifiOff';

const NoInternetScreen = () => {
  return (
    <Box minHeight="100vh" display="flex" justifyContent="center" alignItems="center">
      <Grid container direction="column" alignItems="center" spacing={2}>
        <Grid item>
          <SignalWifiOffIcon fontSize="large" color="error" />
        </Grid>
        <Grid item>
          <Typography variant="h6" align="center">
            No internet connection
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" align="center">
            Please check your internet connection and try again.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NoInternetScreen;
